import styled from 'styled-components';
export const DialogActionsWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: flex-end;
  ${props => props.disableSpacing ? '' : '& > :not(:first-child){margin-left:8px}'}
`;